import styled, {
  keyframes,
} from 'styled-components';

const flash = keyframes`
  0% {
    background: #f3f3f3;
}
  50% {
    background: #f9f9f9;
}
  100% {
    background: #f3f3f3;
}
`;

export const FakeItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 3px 10px;
  width: 100%;
  height: ${props => props.height}px;
  border-bottom: 1px solid #f2f2f2;
  box-sizing: border-box;
  overflow: hidden;
`;

export const FakeItemHeader = styled.div`
  display: block;
  margin: 0 0 .2rem 0;
  width: 30%;
  height: 30%;
  background: #f3f3f3;
  animation: ${flash} 1s infinite;
`;

export const FakeItemTitle = styled.div`
  display: block;
  width: 90%;
  height: 15%;
  background: #f3f3f3;
  animation: ${flash} 1s infinite;
`;

export const FakeItemSubtitle = styled.div`
  display: block;
  width: 70%;
  height: 15%;
  background: #f3f3f3;
  animation: ${flash} 1s infinite;
`;

export const FakeItemFooter = styled.div`
  display: block;
  margin: .2rem 0 0 0;
  width: 40%;
  height: 15%;
  background: #f3f3f3;
  animation: ${flash} 1s infinite;
`;
